const CMSDetails = () => {};
export default CMSDetails;
